import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { environment } from '../../../../environments/environment';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { LoaderService } from '../../loader/loader.service';
import { CarouselComponent } from 'ngx-bootstrap/carousel';
import { TCCPConstantValues } from '../../models/tccp-constants';

@Component({
  selector: 'app-home-carousel',
  templateUrl: './home-carousel.component.html',
  styleUrls: ['./home-carousel.component.scss']
})


export class HomeCarouselComponent implements OnInit {
  public carouselInterval = 5000;
  public activeSlideIndex = 0;
  public showIndicator = false;
  public appName = environment.applicationName;
  public homeImages = [];
  public featureType: string;
  public appBase = TCCPConstantValues[environment.applicationName];
  public imagePath: string = this.appBase.Urls.IMAGE_PATH;

  @ViewChild('carousel', { static: true }) carousel: CarouselComponent;

  setPlay(): void {
    this.carousel.play();
  }
  setPause(): void {
    this.carousel.noPause = false;
    this.carousel.pause();
  }
  constructor(private commonService: TCCPCommonService, private storageService: TCCPLocalStorageService,
    private loader: LoaderService) {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.commonService.startLoaderEmitter.subscribe(flag => {
      if (flag) {
        this.loader.show();
      } else {
        this.loader.hide();
      }
    });
  }
  

  ngOnInit() {
    this.activeSlideIndex = 0;
    this.featureType = this.storageService.getFeatureType();
    this.commonService.hideBreadrumb.emit(true);
    if (this.appName === 'toyota') {
      this.homeImages = this.storageService.getFeatureType() === 'internal' ?
      [`${this.imagePath}assets/images/${this.appName}/toyota_24mm.jpg`,
      `${this.imagePath}assets/images/${this.appName}/homepage1.jpg`,
      `${this.imagePath}assets/images/${this.appName}/homepage2.jpg`,
      `${this.imagePath}assets/images/${this.appName}/homepage3.jpg`]
        :
        [
          `${this.imagePath}assets/images/${this.appName}/toyota_24mm.jpg`,
          `${this.imagePath}assets/images/${this.appName}/toyota_external3.png`,
          `${this.imagePath}assets/images/${this.appName}/toyota_external2.png`,
          `${this.imagePath}assets/images/${this.appName}/toyota_external4.png`]
    } else {
      this.homeImages = this.storageService.getFeatureType() === 'internal' ?
        [
          `${this.imagePath}assets/images/${this.appName}/lexus_24mm.jpg`,
          `${this.imagePath}assets/images/${this.appName}/homepage1.jpg`,
          `${this.imagePath}assets/images/${this.appName}/homepage2.jpg`,
          `${this.imagePath}assets/images/${this.appName}/homepage4.jpg`,
          `${this.imagePath}assets/images/${this.appName}/homepage6.jpg`
        ]
        :
        [
          `${this.imagePath}assets/images/${this.appName}/lexus_24mm.jpg`,
          `${this.imagePath}assets/images/${this.appName}/lexus_external1.png`,
          `${this.imagePath}assets/images/${this.appName}/lexus_external2.png`,
        ];
    }
  }

  @HostListener('window:keydown.ArrowRight', ['$event'])
  arrowRightClickHandler(event: KeyboardEvent) {
    const imageCount = this.homeImages.length;
    if (event.key === 'arrow right' || event.key === 'Spacebar' || event.key === 'Enter') {
      const activeImageIndex = this.activeSlideIndex;
      this.activeSlideIndex = this.homeImages.length - 1 === activeImageIndex ? this.homeImages[0] :
        this.homeImages[activeImageIndex + 1];
    }
  }

  @HostListener('window:keydown.ArrowLeft', ['$event'])
  arrowLeftClickHandler(event: KeyboardEvent) {
    if (event.key === 'arrow left') {
      const activeImageIndex = this.activeSlideIndex;
      this.activeSlideIndex = activeImageIndex === 0 ? this.homeImages[this.homeImages.length - 1] :
        this.homeImages[activeImageIndex - 1];
    }
  }

}
